import React, { Component } from 'react';
import { Layout } from '../components/layout/Layout';
export function Terms() {
  return <Layout data-id="element-881">
      <div className="py-20 bg-white min-h-screen" data-id="element-882">
        <div className="container mx-auto px-4 max-w-3xl" data-id="element-883">
          <h1 className="text-4xl font-bold mb-2" data-id="element-884">Terms of Service</h1>
          <p className="text-muted-foreground mb-12" data-id="element-885">
            Last updated: February 1, 2026
          </p>

          <div className="prose prose-gray max-w-none space-y-8" data-id="element-886">
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-887">
              These Terms of Service ("Terms") govern your access to and use of
              FlingLink (the "Service"). The Service is operated by Acciom
              Limited ("FlingLink", "we", "us", "our"). By using the Service,
              you agree to these Terms.
            </p>

            <section data-id="element-888">
              <h2 className="text-2xl font-bold mb-4" data-id="element-889">Eligibility</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-890">
                You must be at least 18 years old (or the age of majority where
                you live) to use the Service.
              </p>
            </section>

            <section data-id="element-891">
              <h2 className="text-2xl font-bold mb-4" data-id="element-892">Accounts and Security</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-893">
                You are responsible for safeguarding your account and for
                activity under your account. You agree to provide accurate
                information and notify us of unauthorized access.
              </p>
            </section>

            <section data-id="element-894">
              <h2 className="text-2xl font-bold mb-4" data-id="element-895">
                The Service and Your Content
              </h2>
              <p className="text-gray-600 leading-relaxed mb-4" data-id="element-896">
                You may submit content such as messages, prompt responses, and
                media ("User Content").
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-897">
                <li data-id="element-898">
                  You are responsible for your User Content and represent you
                  have the rights to submit it.
                </li>
                <li data-id="element-899">
                  You grant FlingLink a worldwide, non-exclusive, royalty-free
                  licence to host, store, reproduce, modify (for
                  formatting/processing), and display User Content solely to
                  operate and provide the Service (including generating
                  summaries/recaps and enabling sharing you initiate).
                </li>
                <li data-id="element-900">
                  You acknowledge your User Content within a Fling may be
                  visible to the other participant.
                </li>
              </ul>
            </section>

            <section data-id="element-901">
              <h2 className="text-2xl font-bold mb-4" data-id="element-902">Acceptable Use</h2>
              <p className="text-gray-600 leading-relaxed mb-4" data-id="element-903">
                You agree not to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-904">
                <li data-id="element-905">Harass, abuse, threaten, stalk, or impersonate others</li>
                <li data-id="element-906">Post illegal, defamatory, or infringing content</li>
                <li data-id="element-907">
                  Attempt to access accounts/data you are not authorized to
                  access
                </li>
                <li data-id="element-908">
                  Disrupt the Service (scraping, automated abuse, reverse
                  engineering, circumventing security)
                </li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4" data-id="element-909">
                We may remove content or restrict access for violations.
              </p>
            </section>

            <section data-id="element-910">
              <h2 className="text-2xl font-bold mb-4" data-id="element-911">Safety and Reporting</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-912">
                We may provide tools to report abuse and may investigate and
                take action (warnings, suspensions, bans) to protect users and
                the Service.
              </p>
            </section>

            <section data-id="element-913">
              <h2 className="text-2xl font-bold mb-4" data-id="element-914">
                Subscriptions and Payments (If Applicable)
              </h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-915">
                If paid subscriptions are offered, pricing and renewal terms are
                presented at purchase. Payments may be processed by third
                parties. Auto-renewal applies unless cancelled before renewal.
                Refunds are handled as required by law and any purchase terms
                displayed at checkout.
              </p>
            </section>

            <section data-id="element-916">
              <h2 className="text-2xl font-bold mb-4" data-id="element-917">
                Recaps / Automated Outputs
              </h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-918">
                Summaries and recaps are for entertainment and reflection and
                may be inaccurate. You agree not to rely on them as professional
                advice.
              </p>
            </section>

            <section data-id="element-919">
              <h2 className="text-2xl font-bold mb-4" data-id="element-920">Disclaimers</h2>
              <p className="text-gray-600 leading-relaxed uppercase font-medium" data-id="element-921">
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE." TO THE
                MAXIMUM EXTENT PERMITTED BY LAW, FLINGLINK DISCLAIMS ALL
                WARRANTIES, EXPRESS OR IMPLIED.
              </p>
            </section>

            <section data-id="element-922">
              <h2 className="text-2xl font-bold mb-4" data-id="element-923">
                Limitation of Liability
              </h2>
              <p className="text-gray-600 leading-relaxed uppercase font-medium mb-4" data-id="element-924">
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, FLINGLINK WILL NOT BE
                LIABLE FOR INDIRECT OR CONSEQUENTIAL LOSSES. FLINGLINK'S TOTAL
                LIABILITY FOR ALL CLAIMS WILL NOT EXCEED THE GREATER OF: (A)
                AMOUNTS YOU PAID IN THE 12 MONTHS BEFORE THE EVENT GIVING RISE
                TO THE CLAIM; OR (B) £100.
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-925">
                Nothing in these Terms limits liability that cannot be limited
                under law (e.g., fraud, death/personal injury caused by
                negligence where applicable).
              </p>
            </section>

            <section data-id="element-926">
              <h2 className="text-2xl font-bold mb-4" data-id="element-927">Termination</h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-928">
                You may stop using the Service at any time. We may suspend or
                terminate access if you violate these Terms or if necessary to
                protect users or the Service.
              </p>
            </section>

            <section data-id="element-929">
              <h2 className="text-2xl font-bold mb-4" data-id="element-930">
                Governing Law and Jurisdiction
              </h2>
              <p className="text-gray-600 leading-relaxed" data-id="element-931">
                These Terms are governed by the laws of England and Wales. The
                courts of England and Wales will have exclusive jurisdiction
                over disputes arising out of or relating to these Terms or the
                Service.
              </p>
            </section>

            {/* EULA Section */}
            <div className="border-t pt-12 mt-12" data-id="element-932">
              <h1 className="text-3xl font-bold mb-8" data-id="element-933">
                End User Licence Agreement (EULA)
              </h1>

              <p className="text-gray-600 leading-relaxed mb-8" data-id="element-934">
                This End User Licence Agreement ("EULA") governs your use of
                FlingLink software applications and clients (including web/PWA
                and any mobile apps) (the "App"). This EULA is between you and
                Acciom Limited ("FlingLink").
              </p>

              <section data-id="element-935">
                <h2 className="text-2xl font-bold mb-4" data-id="element-936">Licence Grant</h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-937">
                  Subject to your compliance with this EULA, FlingLink grants
                  you a limited, non-exclusive, non-transferable, revocable
                  licence to use the App for personal, non-commercial use.
                </p>
              </section>

              <section className="mt-8" data-id="element-938">
                <h2 className="text-2xl font-bold mb-4" data-id="element-939">Restrictions</h2>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-940">
                  You may not:
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-600" data-id="element-941">
                  <li data-id="element-942">
                    Copy, modify, or create derivative works of the App except
                    as permitted by law
                  </li>
                  <li data-id="element-943">
                    Reverse engineer or attempt to discover source code except
                    where permitted
                  </li>
                  <li data-id="element-944">Rent, lease, sell, sublicense, or transfer the App</li>
                  <li data-id="element-945">Circumvent security or access controls</li>
                </ul>
              </section>

              <section className="mt-8" data-id="element-946">
                <h2 className="text-2xl font-bold mb-4" data-id="element-947">Ownership</h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-948">
                  The App and all intellectual property rights are owned by
                  FlingLink and its licensors. All rights not expressly granted
                  are reserved.
                </p>
              </section>

              <section className="mt-8" data-id="element-949">
                <h2 className="text-2xl font-bold mb-4" data-id="element-950">Updates</h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-951">
                  We may provide updates/patches. This EULA applies to updates
                  unless accompanied by separate terms.
                </p>
              </section>

              <section className="mt-8" data-id="element-952">
                <h2 className="text-2xl font-bold mb-4" data-id="element-953">
                  Third-Party Components
                </h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-954">
                  The App may include third-party components governed by their
                  own licences.
                </p>
              </section>

              <section className="mt-8" data-id="element-955">
                <h2 className="text-2xl font-bold mb-4" data-id="element-956">Termination</h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-957">
                  This EULA remains effective until terminated. It terminates
                  automatically if you breach it. Upon termination, you must
                  stop using the App.
                </p>
              </section>

              <section className="mt-8" data-id="element-958">
                <h2 className="text-2xl font-bold mb-4" data-id="element-959">
                  Disclaimers and Liability
                </h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-960">
                  The App is provided "as is" and "as available," and liability
                  is limited to the maximum extent permitted by law, consistent
                  with the Terms of Service.
                </p>
              </section>

              <section className="mt-8" data-id="element-961">
                <h2 className="text-2xl font-bold mb-4" data-id="element-962">Governing Law</h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-963">
                  This EULA is governed by the laws of England and Wales, and
                  the courts of England and Wales will have exclusive
                  jurisdiction.
                </p>
              </section>

              <section className="mt-8" data-id="element-964">
                <h2 className="text-2xl font-bold mb-4" data-id="element-965">Contact</h2>
                <p className="text-gray-600 leading-relaxed" data-id="element-966">
                  <a href="mailto:help@flinglink.app" className="text-pink-500 hover:underline" data-id="element-967">
                    help@flinglink.app
                  </a>
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </Layout>;
}